export enum AndroidIntent {
    SCREEN_OFF = 'android.intent.action.SCREEN_OFF',
}